import { Row, Space } from 'antd'
import KDateInfo from 'app/components/Modules/DataDisplay/KDateInfo'
import KPriceInfo from 'app/components/Modules/DataDisplay/KPriceInfo'
import KTimeInfo from 'app/components/Modules/DataDisplay/KTimeInfo'
import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import Button from 'app/components/UI-Elements/General/Button'
import Icon from 'app/components/UI-Elements/General/Icon'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import * as React from 'react'

import KNotification from './Container/KNotifications'

const DesignSystem: React.FC = () => {
  return (
    <Space direction="vertical" size="large">
      <Row gutter={[24, 0]}>
        <KCol card span={24} title={'Headings'}>
          <h1>Heading H1</h1>
          <h2>Heading H2</h2>
          <h3>Heading H3</h3>
          <h4>Heading H4</h4>
          <h5>Heading H5</h5>
          <h6>Heading H6</h6>
        </KCol>

        <KCol card span={24} title={'Buttons'}>
          <Space direction="horizontal" wrap>
            <Button type="default">Default</Button>
            <Button type="primary">Primary</Button>
            <Button type="secondary">Secondary</Button>
            <Button type="link">Link</Button>
            <Button type="dashed">Dashed</Button>
            <Button type="default" danger>
              Default Danger
            </Button>
            <Button type="primary" danger>
              Primary Danger
            </Button>
          </Space>
        </KCol>

        <KCol card span={24} title={'Tags'}>
          <Space direction="horizontal" wrap>
            <KTag text="Type: default" type="default" />
            <KTag text="Type: info" type="info" />
            <KTag text="magenta" color="magenta" />
            <KTag text="red" color="red" />
            <KTag text="volcano" color="volcano" />
            <KTag text="orange" color="orange" />
            <KTag text="gold" color="gold" />
            <KTag text="lime" color="lime" />
            <KTag text="green" color="green" />
            <KTag text="cyan" color="cyan" />
            <KTag text="blue" color="blue" />
            <KTag text="geekblue" color="geekblue" />
            <KTag text="purple" color="purple" />
            <KTag
              text="KTag with icon"
              type="info"
              icon={
                <Icon
                  iconStyles={{ height: 16, width: 16, verticalAlign: '-0.25em' }}
                  type="calender"
                />
              }
            />
            <KPriceInfo
              member={{
                discounted_unit_price: 100.11,
                unit: { name: 'day' },
                freeAttachment: false,
                id: 1
              }}
              props={{ type: 'tag' }}
            />
            <KDateInfo dates={{ start_date: '10.10.2021', return_date: '12.12.2021' }} />
            <KTimeInfo member={{ start_time: '10:00', return_time: '12:00' }} />
          </Space>
        </KCol>

        <KCol card span={24} title={'Notifications'}>
          <KNotification />
        </KCol>
      </Row>
    </Space>
  )
}

export default DesignSystem
